import { type FC } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';

import type { DocumentPaneRenderProps } from '@aecom-ai-engineering/react-components';

interface ImageRendererPaneProps {
  active: boolean;
  src: DocumentPaneRenderProps['src'];
  fileName?: string;
}

const ImageRendererPane: FC<ImageRendererPaneProps> = ({ active, src, fileName }) => {
  if (!active) return null;

  const imageUrl = typeof src === 'string' ? src : src instanceof URL ? src.href : undefined;
  if (!imageUrl) return null;

  return (
    <div className="h-full w-full bg-white flex items-center justify-center">
      <TransformWrapper wheel={{ smoothStep: 0.01 }} centerOnInit>
        <TransformComponent wrapperStyle={{ height: '100%', width: '100%' }}>
          <img src={imageUrl} alt={fileName ?? 'Image'} className="max-w-full max-h-full" />
        </TransformComponent>
      </TransformWrapper>
    </div>
  );
};

export function createImageRenderer() {
  return function ImageRenderer(props: DocumentPaneRenderProps) {
    return <ImageRendererPane active={props.active} src={props.src} fileName={props.fileName} />;
  };
}
